class FavoriteButton {
  constructor() {
    this.init();
  }

  init() {
    const favoriteButtons = document.querySelectorAll('[data-favorite-button]');
    
    favoriteButtons.forEach((button) => {
      const productId = button.getAttribute('data-product-id');
      
      // Load saved state from localStorage
      this.loadFavoriteState(button, productId);
      
      // Add click event listener with capture phase to intercept before link
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.toggleFavorite(button, productId);
        return false;
      }, true);
      
      // Also prevent mousedown to avoid any link activation
      button.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    });
  }

  loadFavoriteState(button, productId) {
    const favorites = this.getFavorites();
    const isFavorite = favorites.includes(productId);
    
    if (isFavorite) {
      button.setAttribute('aria-pressed', 'true');
    } else {
      button.setAttribute('aria-pressed', 'false');
    }
  }

  toggleFavorite(button, productId) {
    const favorites = this.getFavorites();
    const isFavorite = favorites.includes(productId);
    
    if (isFavorite) {
      // Remove from favorites
      const index = favorites.indexOf(productId);
      favorites.splice(index, 1);
      button.setAttribute('aria-pressed', 'false');
      this.saveFavorites(favorites);
      
      // Disparar evento de remoção
      document.dispatchEvent(new CustomEvent('favoriteRemoved', { 
        detail: { productId } 
      }));
    } else {
      // Add to favorites
      favorites.push(productId);
      button.setAttribute('aria-pressed', 'true');
      this.saveFavorites(favorites);
      
      // Disparar evento de adição
      document.dispatchEvent(new CustomEvent('favoriteAdded', { 
        detail: { productId } 
      }));
    }
  }

  getFavorites() {
    try {
      const favorites = localStorage.getItem('product-favorites');
      return favorites ? JSON.parse(favorites) : [];
    } catch (e) {
      return [];
    }
  }

  saveFavorites(favorites) {
    try {
      localStorage.setItem('product-favorites', JSON.stringify(favorites));
    } catch (e) {
      console.error('Error saving favorites:', e);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FavoriteButton();
  });
} else {
  new FavoriteButton();
}

// Re-initialize for dynamically loaded content
document.addEventListener('shopify:section:load', () => {
  new FavoriteButton();
});

